import { ComplexRoute } from 'router/components/Routes/Routes';
import { Role } from 'searchality-data';
import VacancyBeforePublishPreview from '../../../VacancyProfile/pages/VacancyBeforePublishPreview';
import VacancyWizard from '../../../../pages/VacancyWizard';

export default [
  {
    path: ':stepName',
    element: VacancyWizard,
    validate: ({ createVacancyWizard }, { stepName }) => {
      const { currentStepIndex, steps } = createVacancyWizard;
      const index = steps.findIndex((s) => s === stepName);
      return index > currentStepIndex ? `../${steps[0]}` : '';
    },
    authorizedRoles: [
      Role.AccountManager,
      Role.AccountOwner,
      Role.HiringManager,
    ],
  },
  {
    path: 'preview',
    element: VacancyBeforePublishPreview,
    authorizedRoles: [
      Role.AccountManager,
      Role.AccountOwner,
      Role.HiringManager,
    ],
  },
  {
    index: true,
    element: VacancyWizard,
    validate: ({ createVacancyWizard }) => {
      const { steps, currentStepIndex } = createVacancyWizard;
      return `${steps[currentStepIndex]}`;
    },
    authorizedRoles: [
      Role.AccountManager,
      Role.AccountOwner,
      Role.HiringManager,
    ],
  },
] as Array<ComplexRoute>;
